import { render, staticRenderFns } from "./EmailOtp.vue?vue&type=template&id=59bfdb73"
import script from "./EmailOtp.vue?vue&type=script&lang=ts"
export * from "./EmailOtp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports